'use strict';

var basePage = require('../pages/base-page.js');
var history = require('../ui/history.js');
var rppDropdown	= require('../components/rpp-dropdown.js');
var sortDropdown = require('../components/sort-dropdown.js');

basePage.init = function() {
	basePage.initBasePage();

	rppDropdown.init();
	sortDropdown.init();

	history.setState({ carChooserSearch: true });

	history.onStateChange(function(state) {
		if (state && state.carChooserSearch) {
			window.location.reload();
		}
	});
};

module.exports = basePage;